export default __webpack_public_path__ + "750f63e.png";